<template>
  <div>
    <v-snackbar v-model="snackbar" :color="color" :timeout="timeout" top vertical>
      {{ error_text }}
      <v-btn dark text @click="close">Close</v-btn>
    </v-snackbar>
  </div>
</template>

<script>
export default {
  name: 'CustomError',
  data() {
    return {
      snackbar: true
    }
  },
  props: {
    error_text: {
      type: String,
      default: 'Error'
    },
    color: {
      type: String,
      default: 'error'
    },
    timeout: {
      type: Number,
      default: 6000
    },
    onClose: {
      type: Function,
      default: () => {}
    }
  },
  methods: {
    close() {
      this.snackbar = false
      this.onClose()
    }
  }
}
</script>

<style lang="scss" scoped></style>
